import config from 'utils/config';
import managedTeams from 'utils/session/managedTeams';
import { hasPrivilege, USER_READ, hasMyTeamsAccess } from 'utils/privileges';
function getMyTeamsLink() {
  var hasUserPrivilege = hasPrivilege(USER_READ);
  var userManagedTeams = managedTeams();
  if (!config.managerReports || !hasMyTeamsAccess()) {
    return null;
  }

  // If user is manager of just a single team, link straight to
  // that team page, otherwise to the overview of teams
  var myTeamsLink = userManagedTeams.length === 1 && !hasUserPrivilege ? "/my-teams/".concat(userManagedTeams[0].id) : '/my-teams';
  return myTeamsLink;
}
export default getMyTeamsLink;